export default "__VITE_ASSET__wwCvQThp__"